import React, { FC } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../constants/aampeTheme';

import FormulaAlternateAction from './FormulaAlternateAction';
import FormulaAlternateExport from './FormulaAlternateExport';

const FormulaAlternateActionMain: FC = () => {
    return (
        <Container>
            <FormulaAlternateExport />
            <FormulaAlternateAction />
        </Container>
    );
};

const Container = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing4(2),
});

export default FormulaAlternateActionMain;
